import Cockpit from "./components/cockpit/Cockpit";

// Single-page Bloomberg-terminal cockpit. No router. Deep-linking happens via
// URL hash (#/<projectId> or #/services) handled inside Cockpit + LeftRail.
export default function App() {
  return <Cockpit />;
}
